module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_0.7cc44cc4.png";